// src/components/energy-reset/EveningSurvey.tsx
type Props = {
  show: boolean;
  onSubmit?: (score: number) => void;
};

export default function EveningSurvey({ show, onSubmit }: Props) {
  if (!show) return null;
  const scores = Array.from({ length: 11 }, (_, i) => i);

  return (
    <div className="rounded-2xl bg-white border border-gray-200 p-4 shadow-sm">
      <div className="font-medium mb-2">Как оцените энергию сегодня?</div>
      <div className="flex flex-wrap gap-2">
        {scores.map((s) => (
          <button
            key={s}
            onClick={() => onSubmit?.(s)}
            className="px-3 py-2 rounded-xl border border-gray-200 hover:border-[#FF6F91] hover:text-[#FF6F91] transition text-sm"
          >
            {s}
          </button>
        ))}
      </div>
      <div className="text-xs opacity-60 mt-2">Это займёт секунду и поможет точнее настраивать практики.</div>
    </div>
  );
}
